import React from "react";
import '../styles/Home.css';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { Link } from "react-router-dom"

import gallery1 from '../styles/images/gallery1.jpg';
import gallery2 from '../styles/images/gallery2.jpg';
import gallery3 from '../styles/images/gallery3.jpg';
import gallery4 from '../styles/images/gallery4.jpg';
import gallery5 from '../styles/images/gallery5.jpg';
import gallery6 from '../styles/images/gallery6.jpg';
import taldea from '../styles/images/taldea.jpg';

// Restaurar los eventos originales
const EVENTS = [ 
];

const Home = () => {
    const [actuacionesRef, actuacionesVisible] = useIntersectionObserver({ threshold: 0.5 });
    const [multimediaRef, multimediaVisible] = useIntersectionObserver({ threshold: 0.5 });
    const [contactoRef, contactoVisible] = useIntersectionObserver({ threshold: 0.5 });
    const [eventosRef, eventosVisible] = useIntersectionObserver({ threshold: 0.5 });

    const cards = [
        { title: 'Emanaldiak', text: 'Kontzertuak eta kalejirak', icon: '🎵' },
        { title: 'Kultura ekitaldiak', text: 'Herriko jaiak', icon: '🎭' },
        { title: 'Ospakizun bereziak', text: 'Ezkontzak', icon: '🎉' },
    ];

    const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

    // Ordenar los eventos por fecha y filtrar los 3 más próximos
    const recentEvents = EVENTS
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .slice(0, 3);

    return (
        <main className="home">
            {/* HERO */}
            <section id="hero" className="hero" aria-label="Hero">
                <div className="container hero__content">
                    <h1 className="hero__title">
                        Alaiak
                        <span className="hero__subtitle">Mungialdeko Soinulari Elkartea</span>
                    </h1>
                    <p className="hero__tagline">Tradizioa eta musika bizirik Mungialdean</p>
                    <div className="hero__cta">
                        <a href="#actuaciones" className="btn btn--primary" aria-label="Emanaldiak ikusi">
                            🎵 Emanaldiak ikusi
                        </a>
                        <a href="#contacto" className="btn btn--ghost" aria-label="Kontaktura joan">
                            📩 Kontaktatu
                        </a>
                    </div>
                </div>
            </section>

            {/* NOR GARA */}
            <section
                id="quienes"
                className="section quienes"
                aria-labelledby="quienes-title"
            >
                <div className="container section__inner">
                    <div className="quienes__text">
                        <h2 id="quienes-title" className="section__title">Nor gara</h2>
                        <p>
                            Alaiak Mungialdeko Soinulari Elkartea musika tradizionala eta herrikoia zabaltzeko sortutako taldea da. Herriak antolatutako ekitaldiak, jaiak eta kultur jarduerak girotzen ditugu urte osoan zehar.
                        </p>
                        <a href="/bio" className="link-cta">👉 Gehiago ezagutu</a>
                    </div>
                    <div className="quienes__media">
                        <img
                            src={taldea}
                            alt="Alaiak taldearen argazkia"
                            loading="lazy"
                        />
                    </div>
                </div>
            </section>

            {/* ZER EGITEN DUGU / EMANALDIAK */}
            <section
                id="actuaciones"
                className={`section actuaciones reveal ${actuacionesVisible ? 'visible' : ''}`}
                aria-labelledby="actuaciones-title"
                ref={actuacionesRef}
            >
                <div className="container">
                    <h2 id="actuaciones-title" className="section__title">Zer egiten dugu</h2>
                    <div className="cards">
                        {cards.map((c, i) => (
                            <article className="card" key={i}>
                                <div className="card__icon" aria-hidden="true">{c.icon}</div>
                                <h3 className="card__title">{c.title}</h3>
                                <p className="card__text">{c.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* HURRENGO EKITALDIAK */}
            <section
                id="proximos-eventos"
                className={`section eventos reveal ${eventosVisible ? 'visible' : ''}`}
                aria-labelledby="eventos-title"
                ref={eventosRef}
            >
                <div className="container">
                    <h2 id="eventos-title" className="section__title">Hurrengo Ekitaldiak</h2>
                    <ul className="eventos-list">
                        {recentEvents.length > 0 ? (
                            <>
                                {recentEvents.map(event => (
                                    <li key={event.id}>
                                        <span className="event-date">{event.date}</span>
                                        <p>📍 {event.title}</p>
                                        <p>🎶 {event.description}</p>
                                    </li>
                                ))}
                                <a href="/events" className="events-link">👉 Agenda osoa ikusi</a>
                            </>
                        ) : (
                            <>
                                <p className="no-events-message">Une honetan ez dugu hurrengo ekitaldirik programatuta. Jarraitu gaitzazu sare sozialetan edo begiratu agenda osoa datozen datetarako.</p>
                                <a href="/events" className="events-link">👉 Agenda osoa ikusi</a>
                            </>
                        )}
                    </ul>
                </div>
            </section>

            {/* MULTIMEDIA */}
            <section
                id="multimedia"
                className={`section multimedia reveal ${multimediaVisible ? 'visible' : ''}`}
                aria-labelledby="multimedia-title"
                ref={multimediaRef}
            >
                <div className="container">
                    <h2 id="multimedia-title" className="section__title">Multimedia</h2>
                    <div className="media-grid">
                        {gallery.map((src, i) => (
                            <img key={i} src={src} alt={`Alaiak galeria ${i + 1}`} loading="lazy" />
                        ))}
                    </div>
                </div>
            </section>

            {/* KONTAKTUA */}
            <section
                id="contacto"
                className={`section contacto reveal ${contactoVisible ? 'visible' : ''}`}
                aria-labelledby="contacto-title"
                ref={contactoRef}
            >
                <div className="container contacto__inner">
                    <h2 id="contacto-title" className="section__title section__title--light">
                        Alaiak zure ekitaldirako nahi duzu?
                    </h2>
                    <div className="contacto__cta">
                        <Link to="/contact" className="btn btn--light">📩 Kontaktatu</Link>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Home;